import { ReactNode } from 'react'

import { ModalBase } from '@/lib/core/components/Modal'

import { Container, Content, Footer, Heading } from './Modal.styles'

export type ModalProps = {
  actions?: ReactNode
  actionsAlignItems?: string
  actionsJustifyContent?: string
  actionsSticky?: boolean
  children?: ReactNode
  heading?: ReactNode
  isActive: boolean
  dataTestId?: string // Add testid support
  containerClassName?: string
  onEscape?: () => void
}

export const Modal = ({
  actions,
  actionsAlignItems = 'flex-end',
  actionsJustifyContent = 'center',
  actionsSticky = false,
  children,
  heading,
  isActive,
  dataTestId,
  containerClassName,
  onEscape,
}: ModalProps) => {
  return (
    <ModalBase isActive={isActive} dataTestId={dataTestId} onEscape={onEscape}>
      <Container className={containerClassName} data-testid={dataTestId ? `${dataTestId}-container` : undefined}>
        {heading && (
          <Heading data-testid={dataTestId ? `${dataTestId}-heading` : undefined}>
            {heading}
          </Heading>
        )}
        <Content data-testid={dataTestId ? `${dataTestId}-content` : undefined}>{children}</Content>
        {actions && (
          <Footer
            $actionsAlignItems={actionsAlignItems}
            $actionsJustifyContent={actionsJustifyContent}
            $actionsSticky={actionsSticky}
            data-testid={dataTestId ? `${dataTestId}-footer` : undefined}
          >
            {actions}
          </Footer>
        )}
      </Container>
    </ModalBase>
  )
}
